import PageWrapper from 'components/utils/PageWrapper';
import MainMarket from 'pages/MainMarket';

export const mainMarketRoutes = {
    path: '/main-market/:mainMarketId',
    element: (
        <PageWrapper titleId="main_market_model_title">
            <MainMarket />
        </PageWrapper>
    ),
};
